import { randomId } from "@/lib/random-id";

const memorySessionIds = new Map<string, string>();

export function getBrowserSessionId(storageKey: string): string {
  const remembered = memorySessionIds.get(storageKey);
  if (remembered) return remembered;

  let sessionId: string | null = null;
  try {
    sessionId = window.sessionStorage.getItem(storageKey);
  } catch {
    sessionId = null;
  }
  if (!sessionId) {
    sessionId = randomId();
    try {
      window.sessionStorage.setItem(storageKey, sessionId);
    } catch {
      memorySessionIds.set(storageKey, sessionId);
    }
  }
  memorySessionIds.set(storageKey, sessionId);
  return sessionId;
}
